module.exports = __webpack_public_path__ + "img/extendHalfColonialWhite.4de63a43.svg";